import type { ReactNode } from 'react'
import React from 'react'
import { css } from '@emotion/core'
import { useContainerWidth } from '@fs/zion-ui'

const conclusionContainerCss = css`
  max-width: 435px;
`

type ConclusionContainerProps = {
  children: ReactNode
}

export default function ConclusionContainer({ children }: ConclusionContainerProps): JSX.Element {
  const atWidth = useContainerWidth()
  return <div css={atWidth({ default: undefined, lg: conclusionContainerCss })}>{children}</div>
}
